<template>
  <div id="change-password">
    <form action="#" @submit.prevent="submitForm">
      <div class="form-group">
        <label for="password">Password Lama</label>
        <input
          type="password"
          name="old_password"
          id="password"
          v-model="old_password"
          placeholder="Password Lama"
          class="form-control"
          required
        />
      </div>
      <div class="form-group">
        <label for="new-password">Password Baru</label>
        <input
          type="password"
          name="old_password"
          id="new-password"
          v-model="new_password"
          placeholder="Password Baru"
          class="form-control"
          required
        />
      </div>
      <div class="form-group">
        <label for="re-password">Ketik Ulang Password Baru</label>
        <input
          type="password"
          name="re_password"
          id="re-password"
          v-model="re_password"
          placeholder="Ketik Ulang Password Baru"
          class="form-control"
          required
        />
        <span class="text-danger" v-if="error">{{ err_text }}</span>
      </div>
      <div class="form-gorup" align="right">
        <button class="btn btn-danger m-r-5" type="button" data-dismiss="modal">
          Batal
        </button>
        <button class="btn btn-warning" type="submit" :disabled="error">
          Simpan
        </button>
      </div>
    </form>
    <floating-loader-component
      v-if="is_loading"
      :with_text="true"
      text="Loading..."
    />
  </div>
</template>

<script>
import floating_loader from "@/views/components/floating_loader.vue";
export default {
  name: "modal_change_password",
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      old_password: null,
      new_password: null,
      re_password: null,
      error: false,
      err_text: "",
      api: process.env.VUE_APP_API_URL,
      is_loading: false,
    };
  },
  methods: {
    submitForm: function () {
      if (!this.error) {
        let api = this.api + "change-password";
        let param = {
          _id: this.data["user"]._id.$oid,
          old_password: btoa(this.old_password),
          new_password: btoa(this.new_password),
          new_password_confirm: btoa(this.re_password),
        };
        this.is_loading = true;
        this.$http
          .post(api, param)
          .then((response) => {
            if (response.status == 200) {
              this.$("#modalSlideUp").modal("hide");
              this.$("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Password berhasil diubah.',
                  position: "top-right",
                  timeout: 5000,
                  type: "success",
                })
                .show();
            } else {
              // console.log(response);
              this.$("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjasi kesalahan pada saar ubah password.',
                  position: "top-right",
                  timeout: 5000,
                  type: "success",
                })
                .show();
            }
          })
          .catch((error) => {
            this.$("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-x-circle"></i> <b>Error!</b> ' +
                  error.response.data.status,
                position: "top-right",
                timeout: 5000,
                type: "error",
              })
              .show();
          })
          .finally(() => {
            this.is_loading = false;
          });
      }
    },
  },
  watch: {
    re_password() {
      if (this.re_password != this.new_password) {
        this.error = true;
        this.err_text = "Password tidak sama";
      } else {
        this.error = false;
      }
    },
  },
};
</script>